export async function request(path, options = {}) {
  const token = localStorage.getItem("token");
  const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(path, { ...options, headers });
  const json = await res.json();

  if (res.status === 401) {
    localStorage.removeItem("token");
    window.location.href = "/login";
    throw new Error("未登录");
  }
  if (json.code !== 0) throw new Error(json.msg || `HTTP ${res.status}`);
  return json.data;
}

export function fetchRevenueSummary() {
  return request("/api/revenue/summary");
}

export function fetchRevenueList(params = {}) {
  const query = new URLSearchParams(params).toString();
  return request(`/api/revenue/list${query ? "?" + query : ""}`);
}

export function fetchRevenueWebsites(params = {}) {
  const query = new URLSearchParams(params).toString();
  return request(`/api/revenue/websites${query ? "?" + query : ""}`);
}

export function fetchRevenueOptions(params = {}) {
  const query = new URLSearchParams(params).toString();
  return request(`/api/revenue/options${query ? "?" + query : ""}`);
}

export function fetchUsers() {
  return request("/api/users");
}

export { createTripitClient, fetchTripitAdunit, fetchTripitData, TRIPIT_API_BASE_URL } from "./tripit.js";
